export default "__VITE_ASSET__dDd608z___"